module.exports = __webpack_public_path__ + "img/arrows-alt-v.5da2a30d.svg";